<template>
  <div class="section-ordering-container">
    <div class="d-flex align-items-center section-ordering-inner">
      <div class="group-checkbox-container">
        <input
          type="checkbox"
          class="checkbox-input"
          :class="{ asc: isCheckedASC }"
          id="choose_Asc"
          :checked="isCheckedASC"
          @change="onSelectedOrdering('asc')"
        />
        <label for="choose_Asc"><ascending-icon class="ascending-icon me-2" />{{ t('component.filter_table.components.ordering.asc') }}</label>
      </div>
      <div class="group-checkbox-container">
        <input
          type="checkbox"
          class="checkbox-input"
          :class="{ desc: isCheckedDESC }"
          id="choose_Desc"
          :checked="isCheckedDESC"
          @change="onSelectedOrdering('desc')"
        />
        <label for="choose_Desc"><descending-icon class="descending-icon me-2" />{{ t('component.filter_table.components.ordering.desc') }}</label>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import AscendingIcon from '@/assets/icons/base/table/AscendingIcon.vue';
import DescendingIcon from '@/assets/icons/base/table/DescendingIcon.vue';

import useOrdering from '../hooks/useOrdering';

interface Props {
  isOpenSorting: boolean;
  selectCurrentValue: any;
  selectSorting: FilterTable.Sorting;
}

const props = defineProps<Props>();

defineEmits(['on-select-ordering', 'on-force-close-sort']);

const { t } = useI18n();
const { isCheckedASC, isCheckedDESC, handleSelectedOrdering, onSelectedOrdering } = useOrdering(props);
</script>

<style lang="scss" scoped>
@import '@/assets/styles/base/filter-table/ordering.scss';
</style>
